<template>
    <div ref="card" class>
        <div class="lb-box is-center">
            <div class="lb-card-content">
                <div>
                    <div :style="getAvatarStyle" class="image is-128x128" />
                </div>
            </div>
            <p class="card-header-title is-size-5 is-block">
                {{ user.name }}
            </p>
            <p class="lb-card-text is-italic">
                {{ user.description }}
            </p>
            <div :class="`lb-role-tag_${role}`">
                {{ $t(`Constants.ROLE_${role.toUpperCase()}`) }}
            </div>
        </div>
    </div>
</template>

<script>
import { avatarStyle } from '@/lib/helpers';
export default {
    props: {
        user: {
            type: Object,
            default() {
                return {};
            },
        },
        role: {
            type: String,
            default: 'participant',
        },
    },
    data() {
        return {};
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        /*hasImage() {
      if (this.user.image.url) {
        return true;
      }
      return false;
    },
    avatarUrl(){
      return this.hasImage?this.user.image.url:this.avatar
    },*/
        getAvatarStyle() {
            return avatarStyle(this.user);
        },
    },
    mounted() {},
    destroyed() {},
    methods: {},
};
</script>

<style scoped>
.toolbar {
    position: absolute;
    top: -20px;
    right: 10px;
}

.lb-card-text {
    padding-top: 0;
    text-align: center;
}

.card-header-title {
    overflow-wrap: break-word;
    padding: 0 1rem;
    text-align: center;
}

.card-header-title.input {
    padding: 0;
}

.lb-card-content > * + * {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.lb-card-content figure {
    margin: 0 auto;
}
</style>
